module.exports = __webpack_public_path__ + "static/media/IMG_0439.6b42f835.jpg";